import { impactPageUrl } from '../../../helpers/impactInBeeld/impactPageUrl'
import { buildEmbedSnippet } from '../../../helpers/impactInBeeld/buildEmbedSnippet'

/**
 * Live-sectie (website-widget, webshop-widget, kassascherm): de te delen
 * publiceer-URL met kopieerknop. Het kassascherm krijgt de live-URL
 * (pagina pollt de totalen); de widgets krijgen daarnaast een kopieerbare
 * iframe-embed-snippet. Kanalen met een koppeling-vereiste melden expliciet
 * dat live meetellen op die koppeling wacht.
 *
 * @param {object} props
 * @param {{id: string, title: string, requirements: Array<string>}} props.channel - Kanaal-config-entry
 * @param {string} props.client - Tenant-CompagnyID
 * @param {string} props.status - Kanaalstatus ('live' toont de werkende URL)
 */
const LiveChannelSection = ({ channel, client, status }) => {
    const origin = window.location.origin

    // Kassascherm = de pollende live-weergave; widgets = normale pagina + embed.
    const isKassascherm = channel.id === 'kassascherm'
    const url = impactPageUrl({ origin, client, live: isKassascherm })
    const embedSnippet = isKassascherm ? null : buildEmbedSnippet({ origin, client })

    const needsConnection = channel.requirements.includes('kassakoppeling')
        || channel.requirements.includes('webshopkoppeling')

    return (
        <div className='impact-channel-live-section'>
            <h3>Jouw live impactpagina</h3>
            <div className='impact-channel-copy-row'>
                <p className='impact-qr-block-url'>{url}</p>
                <button
                    type='button'
                    className='impact-in-beeld-add-button'
                    onClick={() => navigator.clipboard.writeText(url).catch((error) => alert(error))}
                >
                    Kopieer URL
                </button>
            </div>
            {embedSnippet && (
                <>
                    <h3>Embed op je website</h3>
                    <p className='impact-channel-snippet'>{embedSnippet}</p>
                    <button
                        type='button'
                        className='impact-in-beeld-add-button'
                        onClick={() => navigator.clipboard.writeText(embedSnippet).catch((error) => alert(error))}
                    >
                        Kopieer embed
                    </button>
                </>
            )}
            {status !== 'live' && (
                <p className='impact-in-beeld-tab-notice'>
                    De pagina werkt pas na publiceren — hij toont dan de cijfers van dat moment.
                </p>
            )}
            {needsConnection && (
                <p className='impact-in-beeld-tab-pending'>
                    Live meetellen bij elke afrekening wacht op koppeling — verbind je systeem
                    via de Integraties-tab; daarna bewegen de totalen vanzelf mee.
                </p>
            )}
        </div>
    )
}

export default LiveChannelSection
